export default __webpack_public_path__ + "47a5435683298a8bc73c08f744bdc414.png";